import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import TextFormat from '../common/TextFormat.jsx';
import license from './images/license.jpg';

const LicenseBlock = styled.div`
    padding-top: 1.25rem;
    background-color: white;
    text-align: center;
`;

const LicenseImage = styled.img`
    width: 100%;
`;

const LicenseText = styled.div`
    font-size: 1.25rem;
    font-style: italic;
    color: #888888;
    padding-bottom: 1rem;
`;

export class SidebarLicense extends Component {

    static propTypes = {
        text: PropTypes.string.isRequired,
    }

    render() {
        const {text} = this.props;
        return <LicenseBlock>
            <LicenseImage src={license}/>
            <LicenseText>
                <TextFormat text={text} is_first={false} of_many={false}/>
            </LicenseText>
        </LicenseBlock>
    }
}

export default SidebarLicense;